class DoneStageStore {
	constructor() {
		this.actualWeight = 0;
	}

	setActualStage(weight) {
		this.actualWeight = weight;
	}

	getActualWeight() {
		return this.actualWeight;
	}
}
const doneStageStore = new DoneStageStore();
export default doneStageStore;
